<template>
  <div>
    <ministry-breadcrumbs
      :mainTitle="$route.meta.title"
      :breadcrumbs="$route.meta.breadCrumb"
    />
    <b-card>
      <h1>{{ $route.name == "add-role" ? "إضافة دور" : "تعديل دور" }}</h1>
      <hr />
      <validation-observer ref="roleUserManage">
        <b-row>
          <b-col cols="4">
            <form-input
              rules="required"
              label="اسم الدور"
              v-model="objectSubmit.role_name"
            />
          </b-col>
        </b-row>
        <b-card no-body class="border permissions-card mt-1">
          <b-card-header class="p-1">
            <b-card-title class="font-medium-2">
              <feather-icon icon="LockIcon" size="18" />
              <span class="align-middle ml-50">الصلاحيات</span>
            </b-card-title>
          </b-card-header>
          <b-tabs v-if="$route.params.slug === 'MIN'">
            <b-tab title="صلاحيات صفحات الوزارة">
              <data-table
                sticky-header
                ref="estatesTable"
                :fields="fields"
                :ep="`v2/ministry/selects/ministry-permissions`"
                :pagination="false"
                dataPath="data.MIN"
                striped
              >
                <template #cell(permission_name)="data">
                  <div class="d-flex">
                    <span>
                      {{ data.item.name }}
                    </span>
                  </div>
                </template>
                <template #cell()="data">
                  <b-form-checkbox
                    :checked="itemSearsh(data.field.key, data.item.id)"
                    @change="addPermissions(data)"
                  />
                </template>
              </data-table>
            </b-tab>
            <b-tab title="صلاحيات صفحات المنظمات">
              <data-table
                sticky-header
                ref="estatesTable"
                :fields="fields"
                :ep="`v2/ministry/selects/ministry-permissions`"
                :pagination="false"
                dataPath="data.NGO"
                striped
              >
                <template #cell(permission_name)="data">
                  <div class="d-flex">
                    <span>
                      {{ data.item.name }}
                    </span>
                  </div>
                </template>
                <template #cell()="data">
                  <b-form-checkbox
                    :checked="itemSearsh(data.field.key, data.item.id)"
                    @change="addPermissions(data)"
                  />
                </template>
              </data-table>
            </b-tab>
          </b-tabs>
          <data-table
            sticky-header
            v-else
            ref="estatesTable"
            :fields="fields"
            ep="v2/ministry/selects/permissions"
            :pagination="false"
            striped
          >
            <template #cell(permission_name)="data">
              <div class="d-flex">
                <span>
                  {{ data.item.name }}
                </span>
              </div>
            </template>
            <template #cell()="data">
              <b-form-checkbox
                :checked="itemSearsh(data.field.key, data.item.id)"
                @change="addPermissions(data)"
              />
            </template>
          </data-table>
        </b-card>
        <save-btn
          variant="success"
          type="submit"
          :loading="working"
          @click="formSubmit()"
        >
        </save-btn>
      </validation-observer>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormCheckbox,
  BCardHeader,
  BCardTitle,
  BButton,
  BTabs,
  BTab,
} from "bootstrap-vue";
import DataTable from "@/components/data-table/index";
import FormInput from "@/components/form-input/index.vue";
import saveBtn from "@/components/loader-btn";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver } from "vee-validate";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";

export default {
  components: {
    BButton,
    BTabs,
    BTab,
    BCard,
    DataTable,
    BRow,
    BCol,
    FormInput,
    BFormCheckbox,
    BCardHeader,
    BCardTitle,
    saveBtn,
    ValidationObserver,
    MinistryBreadcrumbs,
  },
  props: ["id", "slug"],
  data: () => {
    return {
      selected: false,
      objectSubmit: {
        role_name: "",
        permissions: [],
      },
      permissions: [],
      fields: [
        {
          key: "permission_name",
          label: "الأدوار",
        },
        {
          key: "S",
          label: "إظهار",
        },
        {
          key: "C",
          label: "إضافة",
        },
        {
          key: "D",
          label: "حذف",
        },
        {
          key: "U",
          label: "تعديل",
        },
        {
          key: "O",
          label: "الصلاحيات أخرى ",
        },
      ],
    };
  },
  methods: {
    ...mapActions("Ministry/Settings/Roles", [
      "createRole",
      "updateRole",
      "getParmassins",
    ]),
    itemSearsh(key, id) {
      var idCheck = false;
      if (this.permissions.includes(id)) {
        this.objectSubmit.permissions.forEach((element) => {
          if (id == element.id) {
            if (element.sub_permissions.includes(key)) return (idCheck = true);
          }
        });
      }

      return idCheck;
    },
    formSubmit() {
      console.log('update-role' , this.objectSubmit)
      
      this.$refs.roleUserManage.validate().then(async (success) => {
        if (success && this.$route.name == "add-role") {
          this.createRole({
            data: this.objectSubmit,
            slug: this.$route.params.slug,
          }).then(() => {
            this.$router.push({ name: "settings-roles" });
          });
        } else {
          this.updateRole({
            id: this.id,
            slug: this.slug,
            data: this.objectSubmit,
          }).then(() => {
            this.$router.push({ name: "settings-roles" });
          });
        }
      });
    },

    addSlugIfNotExist(item) {
      if (!this.permissions.includes(item.id)) {
        this.objectSubmit.permissions.push({
          id: item.id,
          slug: item.slug,
          sub_permissions: [],
        });
        this.permissions.push(item.id);
      }
    },

    addPermissions(item) {
      this.addSlugIfNotExist(item.item);
      this.objectSubmit.permissions.map((data) => {
        if (data.id == item.item.id) {
          if (!data.sub_permissions.includes(item.field.key)) {
            data.sub_permissions.push(item.field.key);
          } else {
            data.sub_permissions = data.sub_permissions.filter(
              (data) => data != item.field.key
            );
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters("Ministry/Settings/Roles", [
      "working",
      "parmassins",
      "loadingParmassins",
    ]),
  },
  watch: {
    slug(val) {
      this.getParmassins({ id: this.id, slug: val }).then(() => {
        this.objectSubmit.role_name = this.parmassins.name;
        this.parmassins.permissions.map((item) => {
          this.objectSubmit.permissions.push({
            id: item.permission_id,
            sub_permissions: item.sub_permission,
          });
          this.permissions.push(item.permission_id);
        });
      });
    },
  },
  created() {
    if (this.id) {
      this.getParmassins({ id: this.id, slug: this.slug }).then(() => {
        console.log(this.parmassins);
        this.objectSubmit.role_name = this.parmassins.name;
        this.parmassins.permissions.map((item) => {
          this.objectSubmit.permissions.push({
            id: item.permission_id,
            sub_permissions: item.sub_permission,
          });
          this.permissions.push(item.permission_id);
        });
      });
    }
  },
};
</script>

<style>
.permissions-card .b-table-sticky-header {
  max-height: 600px !important;
}
</style>
